export default "__VITE_ASSET__BVmj4C1S__"